import { action, observable, computed } from "mobx";

import TbSysUserEntity from "./TbSysUserEntity";
import codeDataStore from "common/codedata/store/CodeDataStore";

/**
 * 시스템 - 사용자
 */
export default class TbSysUser extends TbSysUserEntity {
  @observable userNm?: string;

  constructor(data?) {
    super(data);
  }

  @computed
  public getUserNm() {
    return this.userNm;
  }

  @action
  public setUserNm(userNm: string) {
    this.userNm = userNm;
  }

  public getUseYnNm(): string {
    return codeDataStore.getCodeName("/common/useYn", this.useYn);
  }
}
